export default "__VITE_ASSET__BfXVDA8b__"